import React from 'react';
import '../css/Benefits.css'
const Benefits = () => {

  return (
    <div className="section-container">
      <div className="image-column">
        <img
          src="model.jpg"
          alt="Modelo de gráficos"
          style={{ "border": "solid 1px purple" }}
        />
      </div>
      <div className="text-column">
        <h2 className='subtitle-section' style={{ 'maxWidth': '500px' }}>Sua Melhor Escolha</h2>
        <ul className='ul-benefits'>
          <li>Atualizado 2024</li>
          <li>Ferramentas Gratuitas e Online</li>
          <li>Estudos de Caso Reais</li>
          <li>Didática Simples</li>
          <li>Aulas Práticas</li>
          <li>Do Básico ao Avançado</li>
          <li>Não precisa de conhecimento prévio</li>
          <li>Exemplos do Dia a Dia</li>
        </ul>
      </div>
    </div>
  );
};

export default Benefits;
